import { Badge } from "../../../../ui/badge";
import { Users, Clock, CheckCircle, X, Info } from "lucide-react";

export function getStatusBadge(status) {
  const variants = {
    open: {
      color: "bg-blue-100 text-blue-800 border-blue-200",
      text: "Looking for Helpers",
      icon: <Users className="w-3 h-3 mr-1" />
    },
    "in-progress": {
      color: "bg-yellow-100 text-yellow-800 border-yellow-200",
      text: "In Progress",
      icon: <Clock className="w-3 h-3 mr-1" />
    },
    "scheduled": {
      color: "bg-pink-100 text-pink-800 border-pink-200",
      text: "Scheduled Posting",
      icon: <Clock className="w-3 h-3 mr-1" />
    },
    completed: {
      color: "bg-green-100 text-green-800 border-green-200",
      text: "Completed",
      icon: <CheckCircle className="w-3 h-3 mr-1" />
    },
    "not-anymore": {
      color: "bg-red-100 text-red-800 border-red-200",
      text: "Cancelled",
      icon: <X className="w-3 h-3 mr-1" />
    },
  };

  const variant = variants[status] || {
    color: "bg-gray-100 text-gray-800 border-gray-200",
    text: "Unknown",
    icon: <Info className="w-3 h-3 mr-1" />
  };

  return (
    <Badge variant={"outline"} className={`${variant.color} border`}>
      {variant.icon}
      {variant.text}
    </Badge>
  );
}

/**
 * Checks if any helper has marked the job as completed but homeowner hasn't confirmed yet
 * @param {Object} job - The job object containing ShovelerInfo array
 * @returns {Badge|null} - Returns a badge component if helper completed, null otherwise
 */
export function getHelperCompletedBadge(job) {
  // Check if job has ShovelerInfo and it's an array
  if (!job?.ShovelerInfo || !Array.isArray(job.ShovelerInfo)) {
    return null;
  }

  // Check if any shoveller has completed but houseOwner hasn't confirmed
  const helperCompleted = job.ShovelerInfo.some(
    (shoveller) =>
      shoveller.shovellerAction === 'completed' &&
      shoveller.houseOwnerAction !== 'completed'
  );

  if (!helperCompleted) {
    return null;
  }

  return (
    <Badge variant={"outline"} className="bg-orange-100 text-orange-800 border-orange-200 border">
      <CheckCircle className="w-3 h-3 mr-1" />
      Completed by Helper
    </Badge>
  );
}
